
<template>

	<mymodal ref="modal" :title="essence + '. Множественное редактирование. Оценочная группа / подгруппа'" ok="Применить" :reset="reset" :check="check" :submit="submit">

		<tree ref="group_tree" :data="group_tree" :options="group_tree_options" v-on:node:selected="group_select">
			<div slot-scope="{ node }">{{ is_analogues ? node.data.analogues_text : node.data.objects_text }}</div>
		</tree>

	</mymodal>

</template>

<script>

import api from "../../../../api"
import mymodal from "../../../widgets/modal"
import main_tree from "../../../../api/main_tree"

export default
{
	props :
	{
		service : String,
		essence : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {
			
			group_tree : [],
			group_tree_options : { multiple : false },
			group_selected : false,

			is_analogues : false,

		}
	},

	methods :
	{
		check()
		{
			if(this.$refs.group_tree == null)
				return false

			return this.group_selected
		},

		reset()
		{
		},

		execute(is_analogues)
		{
			this.is_analogues = is_analogues
			this.group_tree = main_tree.get(this).main_tree_groups

			this.$refs.modal.execute()
		},

		submit()
		{
			const params = {

				group : this.$refs.group_tree.selected()[0].data.group_id,
				query : this.$parent.get_query(),

			}

			api.call_long_operation(this, this.essence + " / Множественное редактирование / Группировка / Оценочная группа / подгруппа. Присвоение значений из справочника", this.service, "set_group_many", params,
				() =>
				{
					main_tree.create(this)

					this.$emit("need_refresh")
				},
				{ success_msg : `Оценочная группа / подгруппа ${this.essence} - присвоена` }
			)
		},

		group_select()
		{
			this.group_selected = this.$refs.group_tree.selected().length != 0
		},
	}
}

</script>

<style scoped>
* >>> .tree
{
	height: min-content !important;
}
</style>
